export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "medicalchat.worker.cb4a65c2aa0aa16b05b6.worker.js");
}
